import { render, staticRenderFns } from "./weekly-linked-boq-roots-modal.vue?vue&type=template&id=60043c2f&scoped=true"
import script from "./weekly-linked-boq-roots-modal.vue?vue&type=script&lang=js"
export * from "./weekly-linked-boq-roots-modal.vue?vue&type=script&lang=js"
import style0 from "./weekly-linked-boq-roots-modal.vue?vue&type=style&index=0&id=60043c2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60043c2f",
  null
  
)

export default component.exports